export default __webpack_public_path__ + "static/media/rebelai-logo.6cf3e472.png";